<template>
  <v-list-item :three-line="threeLine" @click="onClick">
    <slot/>
  </v-list-item>
</template>

<script>
export default {
  name: "ListItem",
  props: {
    value: {
      type: String
    },
    threeLine: {
      type: Boolean
    }
  },
  methods: {
    onClick() {
      this.$emit("click", this.value)
    }
  }
}
</script>

<style scoped>

</style>